import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { HTTPMethodType } from '../../components/data-grid/data-grid-utils';
import theme from '../../theme';
export const dictionaryListcolDefs = [
    {
        headerName: 'Dictionary Name',
        field: 'name',
        sort: 'asc',
        cellStyle: {
            color: theme.colors.accent[200]
        }
    },
    {
        headerName: 'Status',
        field: 'status',
        valueGetter: (params)=>{
            const targetString = params.data?.status.charAt(0) + params.data?.status.slice(1).toLowerCase();
            return targetString;
        },
        sortable: false
    },
    {
        headerName: 'Security',
        field: 'security',
        cellRenderer: (params)=>{
            return params.data?.unrestrictedIndicator ? /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx("i", {
                    className: "fas fa-unlock lock-color"
                })
            }) : null;
        },
        sortable: false
    },
    {
        headerName: 'Updated By',
        field: 'updatedByFullName',
        sortable: false
    },
    {
        headerName: 'Date Updated',
        field: 'updatedDate',
        sortable: false
    }
];
export const getEndpointDataByTenantId = (tenantId)=>{
    const params = [
        [
            'tenantId',
            `${tenantId}`
        ],
        [
            'derivedIndicator',
            'false'
        ],
        [
            'uniqueByName',
            'true'
        ]
    ];
    const endPoint = {
        endPoint: '/dictionary/v2',
        HTTPMethodType: HTTPMethodType.GET,
        params: params
    };
    return endPoint;
};
export const gridOptions = {
    suppressHorizontalScroll: true,
    paginationPageSizeSelector: false
};
export const pageSizeGridOption = {
    paginationPageSizeSelector: false
};
